var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.meta.layout === 'MainLayout')?_c('main-layout',[_c('router-view')],1):_c('SimpleLayout',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }